import { render, staticRenderFns } from "./AddCustomerGroup.vue?vue&type=template&id=7a907b03&scoped=true"
import script from "./AddCustomerGroup.vue?vue&type=script&lang=js"
export * from "./AddCustomerGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a907b03",
  null
  
)

export default component.exports